// extracted by mini-css-extract-plugin
export default {"eccBenefitsModal":"_0pyCm","link":"BYoz6","content":"M8XlM"};